const STORAGE_KEY = 'mh-terms-accepted';
export const TERMS_VERSION = '2026-07';

export function hasAcceptedTerms() {
  try {
    return localStorage.getItem(STORAGE_KEY) === TERMS_VERSION;
  } catch {
    return false;
  }
}

export function acceptTerms() {
  try {
    localStorage.setItem(STORAGE_KEY, TERMS_VERSION);
  } catch {
    /* ignore */
  }
}
